;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Typography from "@mui/material/Typography"
const BLUE_COLOR_TEXT = "text-[#00b2ff]"

const getNewParagraphLine = (keyName) => {
  return <div className={`h-[10px]`} key={keyName} />
}

export const ACCORDION_ITEMS = [
  {
    accordionSummaryTypography: (
      <Typography>
        1. What is a <span className={BLUE_COLOR_TEXT}>mental health group</span>?
      </Typography>
    ),
    accordionDetailsTypography: (
      <Typography>
        Mental health groups are a common way mental health professionals work with
        clients. A group typically involves an interactive dynamic where three or
        more individuals gather with a defined purpose. Often participants do not
        know each other beforehand, but not always. These groups may endeavor to
        provide specific or general support, healing, and growth. Groups are often
        inspired by particular life experiences, identities, skill building
        interests, or shared goals. Professionals intentionally design and facilitate
        groups so participants actively engage with the material at hand and the
        other members.
      </Typography>
    ),
  },
  {
    accordionSummaryTypography: (
      <Typography>
        2. <span className={BLUE_COLOR_TEXT}>Why should I post</span> a group on
        Zestlife?
      </Typography>
    ),
    accordionDetailsTypography: [
      <Typography key={"q2-1"}>
        <b>Finding and joining groups should be easy.</b>
      </Typography>,
      <Typography key={"q2-2"}>
        The existing tools to search for groups aren’t actually built for groups.
        When looking for a group, clients have to sort through outdated listings on
        directories and many of their requests for help go unanswered. ZestLife is
        designed for groups. All groups you find here are active and joinable with an
        easy option to checkout and request a consultation. The less work clients
        have to do the more likely they are to get in the door.
      </Typography>,
      getNewParagraphLine("q2-3"),
      <Typography key={"q2-4"}>
        <b>Help people beyond your network find your group</b>
      </Typography>,
      <Typography key={"q2-5"}>
        Whether your group is general or you have a specific niche, people need to
        know your group exists. Mental health professionals are consistently looking
        for groups that could benefit their clients. We need a centralized place to
        check what groups are available for people to join.
      </Typography>,
      getNewParagraphLine("q2-6"),
      <Typography key={"q2-7"}>
        We need a place to showcase and market your group to a larger audience.
      </Typography>,
      getNewParagraphLine("q2-8"),
      <Typography key={"q2-9"}>
        <b>Streamline your group management</b>
      </Typography>,
      <Typography key={"q2-10"}>
        Give yourself a one-stop shop for all your group needs. Give your group
        members a homebase for your group where you can manage all of your logistics.
      </Typography>,
      getNewParagraphLine("q2-11"),
      <Typography key={"q2-12"}>
        <b>Enjoy the creative professional community</b>
      </Typography>,
      <Typography key={"q2-13"}>
        Connect with and be a part of a vibrant community of like-minded
        professionals who are passionate about mental health groups. Engage,
        collaborate, and grow together.
      </Typography>,
    ],
  },
  {
    accordionSummaryTypography: (
      <Typography>
        3. What{" "}
        <span className={BLUE_COLOR_TEXT}>types of mental health groups</span> are
        posted here?
      </Typography>
    ),
    accordionDetailsTypography: [
      <Typography key={"q3-1"}>We categorize groups into 5 main types.</Typography>,
      getNewParagraphLine("q3-2"),
      <Typography key={"q3-3"}>
        <span className={"font-bold"}>Therapy groups</span> refers to the larger
        umbrella of groups that use specific therapeutic modalities. This category
        includes group therapy, which is distinguished by interpersonal processing.
      </Typography>,
      getNewParagraphLine("q3-4"),
      <Typography key={"q3-5"}>
        <span className={"font-bold"}>Support groups</span> revolve around members
        supporting each other through shared experiences that they all have either
        been through or are currently going through.
      </Typography>,
      getNewParagraphLine("q3-6"),
      <Typography key={"q3-7"}>
        <span className={"font-bold"}>Workshops </span> center around focused
        skill-building.
      </Typography>,
      getNewParagraphLine("q3-8"),
      <Typography key={"q3-9"}>
        <span className={"font-bold"}>Retreats</span> are defined by setting aside
        dedicated time from the regular rhythm of day-to-day life to focus on a
        specific subject area while at a specific location.
      </Typography>,
      getNewParagraphLine("q3-10"),
      <Typography key={"q3-11"}>
        <span className={"font-bold"}>Clinical peer groups</span> is group work for
        clinicians committed to learning and growing as mental health professionals.
      </Typography>,
      getNewParagraphLine("q3-12"),
      <Typography key={"q3-13"}>
        Every group listed on ZestLife is interactive, independently created, and
        led. In contrast, more passive experiences like lectures or courses, where
        one individual primarily speaks, are often more individualistic and,
        therefore, do not fit with the definition of a mental health group.
      </Typography>,
    ],
  },
  {
    accordionSummaryTypography: (
      <Typography>
        4. How do I <span className={BLUE_COLOR_TEXT}>post a group</span>?
      </Typography>
    ),
    accordionDetailsTypography: [
      <Typography key={"q4-1"}>
        Simply click the 'Post a Group' button on the website's menu bar or homepage.
        You'll be guided to create an account, if you haven’t already, and then to
        complete the onboarding steps.
      </Typography>,
      getNewParagraphLine("q4-2"),
      <Typography key={"q4-3"}>
        We've created these onboarding steps to do our due diligence to verify
        providers and enable potential clients to book a seat or consultation
        directly, rather than having to reach out to see if and when the group is
        running. Once you complete all onboarding steps and submit your listing,
        please allow us a few business days to review for publication.
      </Typography>,
      getNewParagraphLine("q4-4"),
      <Typography key={"q4-5"}>
        We’re happy to help you get set up or learn more. Please reach out to us at
        support@getzestlife.com to schedule a demo or receive our how-to guide.
      </Typography>,
    ],
  },
  {
    accordionSummaryTypography: (
      <Typography>
        5. How can someone <span className={BLUE_COLOR_TEXT}>join a group</span>?
      </Typography>
    ),
    accordionDetailsTypography: [
      <Typography key={"q5-1"}>
        New members reserve a spot in your group and check out with a click of a
        button. Unlike directories, there is no need for a back-and-forth asking if a
        group is running. We make it easy for prospective members to submit payment
        and commit to joining a group.
      </Typography>,
      getNewParagraphLine("q5-2"),
      <Typography key={"q5-3"}>
        If consultations are needed before admitting members, we let them know their
        acceptance is dependent on meeting with you. We verify their card has the
        required funds, ensuring payment is available upon admittance. If someone
        isn't a fit, declining their admission releases the funds back to their card.
      </Typography>,
      getNewParagraphLine("q5-4"),
      <Typography key={"q5-5"}>
        People face many issues getting help. When they find the group they want to
        join it should be easy. Welcome to ZestLife.
      </Typography>,
    ],
  },
  {
    accordionSummaryTypography: (
      <Typography>
        6. Can I schedule a <span className={BLUE_COLOR_TEXT}>consultation</span>{" "}
        before accepting a client?
      </Typography>
    ),
    accordionDetailsTypography: (
      <Typography>
        Yes, you can. During the process of posting your group, you’ll be asked a
        series of questions to help market your group. One of these questions is
        whether you will require a consultation. If you select “yes,” then you'll
        need to promptly schedule a consultation with potential members before
        accepting or denying their membership to your group.
      </Typography>
    ),
  },
  {
    accordionSummaryTypography: (
      <Typography>
        7. How does ZestLife help with{" "}
        <span className={BLUE_COLOR_TEXT}>billing</span>?
      </Typography>
    ),
    accordionDetailsTypography: [
      <Typography key={"q7-1"}>
        <span className={"font-bold"}>Set your rate:</span> This is your group, we
        just help you run it. You set the participation fee, cancellation policy, and
        whether clients pay upfront for a series or pay-per-session.
      </Typography>,
      getNewParagraphLine("q7-2"),
      <Typography key={"q7-3"}>
        <b>Pay-Per-Session Convenience:</b> We help you get paid on time by ensuring
        your members have sufficient funds to pay for the upcoming session. We place
        a temporary hold for the session cost a few days before each session and will
        notify you and the member if any card issue arises.
      </Typography>,
      getNewParagraphLine("q7-4"),
      <Typography key={"q7-5"}>
        <b>Consultations:</b> If you require consultations before admitting members,
        we verify their card has the required funds available to pay upon your
        approval accepting them into the group. If someone isn't a fit, declining
        their admission releases the funds back to their card.
      </Typography>,
      getNewParagraphLine("q7-6"),
      <Typography key={"q7-7"}>
        We streamline the process of joining and attending your group to ensure a
        hassle-free billing experience for both you and your members.
      </Typography>,
    ],
  },
  {
    accordionSummaryTypography: (
      <Typography>
        8. <span className={BLUE_COLOR_TEXT}>Are groups more work</span> than
        individual one-on-one sessions?
      </Typography>
    ),
    accordionDetailsTypography: (
      <Typography>
        Facilitating groups may come easier for some and feel more challenging for
        others. This is because managing group dynamics requires different skills and
        expertise versus one-on-one sessions. Additionally, factors like the group's
        purpose, participant demographics, and the timeframe can influence your
        experience. A successfully facilitated group often lifts some therapeutic
        workload off the provider, as participants grow in their ability to offer
        mutual care and support for each other.
      </Typography>
    ),
  },
  {
    accordionSummaryTypography: (
      <Typography>
        9. Why should I consider{" "}
        <span className={BLUE_COLOR_TEXT}>offering more groups in my business</span>?
      </Typography>
    ),
    accordionDetailsTypography: (
      <Typography>
        Expanding your group offerings is a powerful way to reach and help more
        people. Compared to primarily working one-on-one, consistent group work can
        also lead to reduced work hours, additional revenue streams, and increased
        income. Many providers derive significant satisfaction from group work and
        find it reduces burnout. Additionally, working with clients in a group
        setting can lead to working with them one-on-one.
      </Typography>
    ),
  },
  {
    accordionSummaryTypography: (
      <Typography>
        10. If my <span className={BLUE_COLOR_TEXT}>waitlist is full</span>, is there
        still any reason for me to sign up?
      </Typography>
    ),
    accordionDetailsTypography: (
      <Typography>
        Absolutely! Reaching out for support is a significant step for someone. If
        they are turned away without alternatives, they may become discouraged and
        hesitant to seek further assistance. Being aware of other groups that are
        currently accepting new clients allows you to provide effective referrals and
        uphold your commitment to mental health. Making referrals is also an
        excellent way to expand your professional network and community.
      </Typography>
    ),
  },
  {
    accordionSummaryTypography: (
      <Typography>
        11. If <span className={BLUE_COLOR_TEXT}> I don’t run any groups</span>{" "}
        myself, why might I create an account here?
      </Typography>
    ),
    accordionDetailsTypography: (
      <Typography>
        As a healthcare provider, you are in a special position to help people see
        beyond their current circumstances. You may recognize someone’s blind spot
        and help them identify what workshop, support group, or group therapy
        experiences may address that area. ZestLife serves as a resource for finding
        group offerings. Having an account here enables you to stay informed of group
        offerings which may benefit those in your life.
      </Typography>
    ),
  },
  {
    accordionSummaryTypography: (
      <Typography>
        12. How much does it{" "}
        <span className={BLUE_COLOR_TEXT}>cost to post a group</span>?
      </Typography>
    ),
    accordionDetailsTypography: [
      <Typography>
        Posting groups are free, so there is no financial barrier to publication.
        It’s just a 2.9% + $0.30 per transaction. Facilitate the entire group
        lifecycle including: payments, booking members, taking attendance, storing
        meeting plans, writing notes, and offering a client portal for detailing
        meeting logistics. This fee covers operational, infrastructure, and
        advertising costs and payment processing fees to make this vision a
        sustainable reality.
      </Typography>,
    ],
  },
  {
    accordionSummaryTypography: (
      <Typography>
        13. How long do I have{" "}
        <span className={BLUE_COLOR_TEXT}>access to my notes</span>?
      </Typography>
    ),
    accordionDetailsTypography: [
      <Typography>
        Forever. Your notes are attached to your account and can be accessed anytime
        from your account. We will not delete notes unless required to by law or at
        your request.
      </Typography>,
    ],
  },
  {
    accordionSummaryTypography: (
      <Typography>
        14. How does ZestLife handle{" "}
        <span className={BLUE_COLOR_TEXT}>privacy and security</span>?
      </Typography>
    ),
    accordionDetailsTypography: [
      <Typography>
        ZestLife recognizes the sensitive nature of your data and are deeply
        committed to ensuring your confidentiality, security, and proper handling. We
        take all necessary steps to protect data.
      </Typography>,
    ],
  },
]
